function FormBuilderField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
		},
		controller: function($parse, $scope, FormService, $q, Classes, $timeout, $translate, $element, $window) {
			var self = this;
			self.formBuilder = null;
			self.working = false;
			self.formitems = [];

			


			self.makeFormInput = function(form_type, name, options) {
				var field = {
					//client:undefined,
					//default:undefined,
					description: '',
					editable:"true",
					groups:['survey-form'],
					name: name || 'default_value',  // every field has the same name, different object
					required: options.required || false,
					title: options.label,
					type: form_type,
					visible: options.visible || "true",
					client: {
						description: options.description || null,
						placeholder: options.placeholder || ' ',
						options_inline: options.options_inline || null
					}
				};
				if (options.values) {
					field.dictionary = options.values
				}
				if (form_type == "FormFilesField") {
					field.client.multiple = options.multiple;
					field.client.max_file_size = options.max_file_size;
					field.client.max_files = options.max_files;
				}
				return field;
			}

			self.makeFormItem = function(type, spec) {
				var item = angular.copy(spec);
				item.options.name = item.options.name || _.camelCase(type) + '_' + Date.now();
				item.options.type = type;
				item.example_input = self.makeFormInput(item.form_type, 'default_value', item.options || {})
				item.config_form_fields = [
					self.makeFormInput("Field", 'label', {label: 'Input title', required: true}),
					self.makeFormInput("BooleanField", 'required', {label: 'Required'}),
					self.makeFormInput("Field", 'placeholder', {label: 'Input placeholder'}),
					self.makeFormInput("Field", 'description', {label: 'Input description'}),
				]
				if (item.options.values) {
					item.config_form_fields.push(self.makeFormInput("BooleanField", 'options_inline', {label: 'Display options inline'}));
				}
				if (item.options.values) {
					var value_field = self.makeFormInput("BackReferenceField", 'values', {label: 'Options'});
					value_field.fields = [
						self.makeFormInput("Field", 'label', {label: 'Option label'}),
						self.makeFormInput("Field", 'value', {label: 'Option value'}),
					];
					value_field.fields[1].default = function(){
						var i=0;
						while(true) {
							i++;
							var id = 'opcja-' + i;
							var exists = false;
							for(var j=0; j<item.options.values.length; j++) {
								if (id == item.options.values[j].value) exists = true;
							}
							if (!exists) break;
						}
						return 'opcja-' + i
					}
					value_field.join = {backref: null}
					value_field.client.display = 'table',
					item.config_form_fields.push(value_field)
				}

				if (type == 'file') {
					item.config_form_fields.push(self.makeFormInput("BooleanField", 'multiple', {label: 'Allow multiple files'}));
					item.config_form_fields.push(self.makeFormInput("IntField", 'max_file_size', {label: 'Maximum single file size in MB'}));
					var max_files = self.makeFormInput("IntField", 'max_files', {label: 'Maximum number of files'})
					max_files.visible = "multiple == true"
					item.config_form_fields.push(max_files);
				}

				// conditional
				item.config_form_fields.push(self.makeFormInput("BooleanField", 'conditional', {label: 'Is conditional?'}));
				var conditional_field_list = self.makeFormInput("DictionaryField", 'visible_reference', {label: 'Observed field'});
				conditional_field_list.dict = function(){
					return $q.resolve(self.formitems.map(function(item){return [item.options.name, item.options.label]}));
				};
				conditional_field_list.visible = "conditional == true"
				item.config_form_fields.push(conditional_field_list)

				var conditional_field_value = self.makeFormInput("Field", 'visible_value', {label: 'Required value'});
				conditional_field_value.visible = "conditional == true && visible_reference"
				item.config_form_fields.push(conditional_field_value)
				// END conditional

				// typeUserAttrs
				if (self.field.client && self.field.client.typeUserAttrs && self.field.client.typeUserAttrs[type]) {
					for (var fname in self.field.client.typeUserAttrs[type]) {
						var fspec = self.field.client.typeUserAttrs[type][fname];
						if (fspec.options) {
							item.config_form_fields.push(self.makeFormInput("DictionaryField", fname, {label: fspec.label, values:fspec.options, required: fspec.required}))
						} else {
							item.config_form_fields.push(self.makeFormInput("Field", fname, {label: fspec.label, required: fspec.required}))
						}
					}
				}


				item.config_form_errors = {}
				item.has_errors = false;
				item.stop_watching_options = $scope.$watch(function(){return item.options;}, function(currval, oldval){
					if (oldval && currval) {
						item.example_input.title = item.options.label;
						item.example_input.required = item.options.required;

						// errors
						item.has_errors = false;
						for (var i=0; i<item.config_form_fields.length; i++) {
							var fcfield = item.config_form_fields[i];
							if (fcfield.required && !item.options[fcfield.name]) {
								item.config_form_errors[fcfield.name] = 'This field is required';
								item.has_errors = true;
							} else {
								item.config_form_errors[fcfield.name] = null;
							}
						}
					}
				}, true);

				item.stop_watching_values = $scope.$watch(function(){return item.default_value;}, function(currval, oldval){
					self.updateObjectValue();
				}, true);
				return item;
			}

			self.fields = {
				text: {
					title: $translate.instant('Text field'),
					form_type: 'Field',
					options: {
						label: $translate.instant('Text field'),
						name: null,  // fill dynamically
						//description: "",
						//placeholder: "",
					},
					default_value: "",
					erase: function(item) {
						item.default_value = "";
					}
				},
				textarea: {
					title: $translate.instant('Large text field'),
					form_type: 'TextField',
					options: {
						label: $translate.instant('Large text field'),
					},
					default_value: "",
					erase: function(item) {
						item.default_value = "";
					}
				},
				number: {
					title: $translate.instant('Number field'),
					form_type: 'IntField',
					options: {
						label: $translate.instant('Number field'),
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
					}
				},
				date: {
					title: $translate.instant('Date field'),
					form_type: 'DateField',
					options: {
						label: $translate.instant('Date field'),
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
					}
				},
				select: {
					title: $translate.instant('Select field'),
					form_type: 'FormSelectField',
					options: {
						label: $translate.instant('Select field'),
						values: [
							{label:'Opcja 1', value:'opcja-1'},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				'radio-group': {
					title: $translate.instant('Radio select field'),
					form_type: 'FormRadioGroupField',
					options: {
						label: $translate.instant('Radio select field'),
						values: [
							{label:'Opcja 1', value:'opcja-1'},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = null;
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				'checkbox-group': {
					title: $translate.instant('Checkbox field'),
					form_type: 'FormChecboxGroupField',
					options: {
						label: 'Checkbox field',
						values: [
							{label:'Opcja 1', value:'opcja-1', /* selected: true */},
							{label:'Opcja 2', value:'opcja-2'},
							{label:'Opcja 3', value:'opcja-3'},
						],
					},
					default_value: null,
					erase: function(item) {
						item.default_value = [];
						for (var i=0; i<item.options.values; i++) delete item.options.values[i].selected;
					}
				},
				file: {
					title: $translate.instant('File upload'),
					form_type: 'FormFilesField',
					options: {
						label: $translate.instant('File upload'),
						multiple: false,
						max_file_size: 5,
						max_files: 10,
					},
					default_value: [],
					erase: function(item) {
						item.default_value = [];
					}
				},
			}
			
			self.controlOrder = [
				'text',
				'textarea',
				'number',
				'date',
				'select',
				'checkbox-group',
				'radio-group',
				'file'
			];

			self.typesDragOptions = {
				clone: true,
				accept: function(){return false;},
				itemMoved: function (eventObj) {
					eventObj.dest.sortableScope.removeItem(eventObj.dest.index);
					var type = eventObj.source.itemScope.modelValue;
					if (typeof type == "string") {
						var item = self.makeFormItem(type, self.fields[type]);
						item.editing = true;
						eventObj.dest.sortableScope.insertItem(eventObj.dest.index, item);
					}
				}
			}

			self.fieldsDragOptions = {
				containerPositioning: 'relative',
				containment:'.formbuilder-items',
				orderChanged: function (eventObj) {
					self.updateObjectValue();
				}
			}

			self.appendFormItem = function(type) {
				var item = self.makeFormItem(type, self.fields[type]);
				self.formitems.push(item);
				self.updateObjectValue();
			}

			self.cloneFormItem = function(index) {
				var olditem = angular.copy(self.formitems[index]);
				olditem.options.name = null;
				var item = self.makeFormItem(self.formitems[index].options.type, olditem);
				self.formitems.splice(index + 1, 0, item);
				self.updateObjectValue();
			}

			self.deleteFormItem = function(index) {
				self.formitems[index].stop_watching_options()
				self.formitems[index].stop_watching_values()
				self.formitems.splice(index, 1);
				self.updateObjectValue();
			}

			self.toggleEditing = function(item) {
				item.editing=!item.editing;
				if (!item.editing) {
					item.example_input = self.makeFormInput(item.form_type, 'default_value', item.options || {})
				}
			}

			// read write

			self.updateObjectValue = function() {
				var value = self.object[self.field.name] || []
				if (typeof value.length != "number") value = [];
				value.length = 0;
				for (var i=0; i<self.formitems.length; i++) {
					var item = self.formitems[i];
					var valueitem = item.options;

					if (valueitem.type == 'checkbox-group') {
						var formval = item.default_value;
						for (var v=0; v<valueitem.values.length; v++) {
							valueitem.values[v].selected = formval.indexOf(valueitem.values[v].value) != -1;
						}
					} else if (valueitem.type == 'radio-group' || valueitem.type == 'select') {
						var formval = item.default_value;
						for (var v=0; v<valueitem.values.length; v++) {
							valueitem.values[v].selected = valueitem.values[v].value == formval;
						}
					} else {
						valueitem.value = item.default_value;
					}

					value.push(valueitem); 
				} 
				self.object[self.field.name] = value;
			}

			self.readObjectValue = function() {
				var value = self.object[self.field.name] || [];
				if (typeof value.length != "number") value = [];
				self.formitems.length = 0;
				for (var i=0; i<value.length; i++) {
					var valueitem = value[i];
					var spec = angular.copy(self.fields[valueitem.type]);
					spec.options = valueitem;
					var item = self.makeFormItem(valueitem.type, spec);
					if (valueitem.type == 'checkbox-group') {
						var formval = [];
						for (var v=0; v<valueitem.values.length; v++) {
							if (valueitem.values[v].selected) formval.push(valueitem.values[v].value);
						}
						item.default_value = formval
					} else if (valueitem.type == 'radio-group' || valueitem.type == 'select') {
						var formval = null;
						for (var v=0; v<valueitem.values.length; v++) {
							if (valueitem.values[v].selected) formval = valueitem.values[v].value;
						}
						item.default_value = formval
					} else {
						item.default_value = valueitem.value
					}
					
					self.formitems.push(item)
				}
			}

			// controls lock bug fix (consider the fixed top bar)
			var fixedControls = 0;
			var itemsDiv = $element.find('.formbuilder-items');
			var toolboxDiv = $element.find('.formbuilder-toolbox');
			var topnavDiv = angular.element($window.document).find('#topnav');

			self.updateToolboxPosition = function () { 
				var offsetTop = angular.element($window).scrollTop();
				var scrollSpace = itemsDiv.height() - toolboxDiv.height();
				var fixedOffset = topnavDiv.height() + 20;
				var minOffsetTop = itemsDiv.offset().top - (topnavDiv.height() + 20);
				var maxOffsetTop = minOffsetTop + scrollSpace;

				if (scrollSpace <= 100) {
					return;   // do not fix toolbas for small distances
				}

				if (offsetTop < minOffsetTop || 
					toolboxDiv.parent().css('float') != 'left'   // kolumna jedna nad drugą - wąski ekran
				) {
					if (fixedControls != 1){
						toolboxDiv.css({
							'position': 'static',
							'left': 'auto',
							'top': 'auto',
							'width': 'auto',
							'margin-top': 0,
						});
						fixedControls = 1;
					} 
				} else if (offsetTop < maxOffsetTop) {
					if (fixedControls != 2){
						toolboxDiv.css({
							'position': 'fixed',
							'left': toolboxDiv.offset().left,
							'top': fixedOffset + 'px',
							'width': toolboxDiv.width() + 'px',
							'margin-top': 0,
						});
						fixedControls = 2;
					}
				} else {
					if (fixedControls != 3){
						toolboxDiv.css({
							'position': 'static',
							'left': 'auto',
							'top': 'auto',
							'width': 'auto',
							'margin-top': scrollSpace + 'px',
						});
						fixedControls = 3;
					}
				}
			}
			angular.element($window).bind("scroll resize", self.updateToolboxPosition)

			$scope.$on("$destroy", function handler() {
				// destruction code here
				angular.element($window).unbind("scroll resize", self.updateToolboxPosition)
			});

			$scope.$watch(function(){return self.object[self.field.name];}, self.readObjectValue);
			

		},
		controllerAs: '$fb'
	}
}



function FormViewField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<fieldErrors',
			readonly: '<',
		},
		controller: function($parse, $scope, FormService, $q, Classes, $timeout) {
			var self = this;
			
			self.Classes = Classes
			self.items = self.object[self.field.name];

			self.formFields = [];
			self.formValues = {};
			self.formLayout = ['survey-form'];
			self.formErrors = [];
			self.formLabelClass = (self.field.client? self.field.client.formLabelClass : null) || "text-left";
			self.formEditorClass = (self.field.client? self.field.client.formEditorClass : null) || "";

			self.convertFieldTypes = {
				'text': 'Field',
				'textarea': 'TextField',
				'number': 'IntField',
				'date': 'DateField',
				'select': 'FormSelectField',
				'checkbox-group': 'FormChecboxGroupField',
				'radio-group': 'FormRadioGroupField',
				'file': 'FormFilesField',
			}

			self.updateFormFieldsAndValues = function(formSettingsData) {
				if (!self.formValues.__parent) {  // na przyszłość do ew. ukrywania pól np. __parent.event.title
					Object.defineProperty(self.formValues, '__parent', {
						enumerable: false,
						configurable: true,
						writable: false,
						value: self.object
					});
				}
				var newFormFields = {};
				angular.forEach(formSettingsData, function(value, key) {
					if(self.convertFieldTypes[value.type]){
						var field = {
							//client:undefined,
							//default:undefined,
							description: 'test',
							editable:"true",
							groups:['survey-form'],
							name: value.name,
							required: value.required || false,
							title: value.label,
							type: self.convertFieldTypes[value.type],
							visible:"true",
							client: {
								description: value.description,
								placeholder: value.placeholder || ' ',
								options_inline: value.options_inline
							}
						}
						if(value.conditional && value.visible_reference && value.visible_value){
								field.visible = value.visible_reference + ".length ? " + value.visible_reference + ".indexOf('" + value.visible_value + "') != -1 : " + value.visible_reference + " == '" + value.visible_value + "'";
						}
						if (value.type == 'file') {
							field.client.multiple = value.multiple;
							field.client.max_file_size = value.max_file_size;
							field.client.max_files = value.max_files;
						}
						if (self.field.client && self.field.client.child_box_template_url) {
							field.client.box_template_url = self.field.client.child_box_template_url;
						}
						if(value.type == 'checkbox-group' || value.type == 'radio-group' || value.type == 'select'){
							var fieldDict = [];
							self.formValues[value.name] = value.type == 'checkbox-group' ? [] : null;
							for (var i = 0; i < value.values.length; i++) {
								fieldDict.push({
									value: value.values[i].value, 
									label: value.values[i].label
								});
								if (value.values[i].selected) {
									if (value.type == 'checkbox-group') self.formValues[value.name].push(value.values[i].value);
									if (value.type == 'radio-group' || value.type == 'select') self.formValues[value.name] = value.values[i].value;
								}
							}
							field.dictionary = fieldDict;
						}
						if (value.value) {
							self.formValues[value.name] = value.value;
						}

						newFormFields[key] = self.formFields[key] || {}
						_.merge(newFormFields[key], field)  // recursive overwrite
					}
					self.formFields = newFormFields;
				});
			}
			
			self.updateFormFieldsAndValues(self.object[self.field.name]);

			$scope.$watch(function(){return self.object[self.field.name]}, function(formSettingsData, old){
				self.items = formSettingsData;
				if (formSettingsData && formSettingsData !== old) {
					self.updateFormFieldsAndValues(formSettingsData);
				}
			}, true);

			if (!self.readonly) {
				$scope.$watch(function(){return self.formValues;}, function(formValues){
					// form was edited
					angular.forEach(self.object[self.field.name], function(value, key) {
						if(self.convertFieldTypes[value.type]){
							if(value.type == 'checkbox-group'){
								for (var i = 0; i < value.values.length; i++) {
									value.values[i].selected = formValues[value.name].indexOf(value.values[i].value) >= 0;
								}
							} else if (value.type == 'radio-group' || value.type == 'select') {
								for (var i = 0; i < value.values.length; i++) {
									value.values[i].selected = formValues[value.name] == value.values[i].value;
								}
							} else {
								value.value = formValues[value.name];
							}
						}
					});
				}, true);

				$scope.$watch(function(){return self.errors ? self.errors[self.field.name] : null}, function(errors) {
					self.formErrors = {}
					for (var key in errors) {
						var fname = self.object[self.field.name][key].name;
						self.formErrors[fname] = errors[key];
					}
				})
			}
			


			// TODO: fieldErrors
	
		},
		controllerAs: '$form'
	}
}

function FormBuilderCheckboxGroup() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldobject',
		},
		controller: function($parse, $scope) {
			var self = this;
			this.items = [];
			
			self.object[self.field.name] = self.object[self.field.name] || [];
			
			self.updateItems = function(){
				self.items.length = 0;
				for (var i=0; i<self.field.dictionary.length; i++) {
					var item = self.field.dictionary[i];
					if (self.object[self.field.name].indexOf(item.value) != -1) {
						item.selected = true;
					}
					self.items.push(item);
				}
			}
			$scope.$watchCollection(function(){return self.field.dictionary}, self.updateItems);

			$scope.$watch(function() { 
				return _.map(self.items, function(o){
						return {
							label:o.label,
							selected:o.selected,
							value:o.value
						}
					}
				)
			}, function(newValue, oldValue) {
				if (newValue == oldValue) return;
				self.object[self.field.name].length = 0;
				for (var i in self.items) {
					var item = self.items[i];
					if (item && item.selected) {
						self.object[self.field.name].push(item.value);
					}
				}
			}, true);
		},
		controllerAs: '$formBuilderCheckboxGroup'
	}
}

function FormFilesField($q) {
	return {
		require: ['ngModel', '^^?fieldBox'],
		link: function($scope, element, attrs, controllers) {
			var ngModel = controllers[0];
			var fieldBox = controllers[1];
			var self = {};
			ngModel.$setViewValue(ngModel.$viewValue || [])
			
			var slice = Array.prototype.slice;
	
			self.message = null;
			self.busy = false;
			self.items = [];
			self.invalidFiles = [];
			self.invalidItems = [];

			self.readFile = function (file) {
				var deferred = $q.defer();

				var reader = new FileReader()
				reader.onload = function(e){
					deferred.resolve({
						mime: file.type,
						filename: file.name,
						data: e.target.result,
						title: file.name
					});
				}
				reader.onerror = function(e) {
					deferred.reject(e);
				}
				reader.readAsDataURL(file);

				return deferred.promise;
			}
			
			self.uploadFiles = function(files) {
				self.is_busy = true;
				fieldBox.setFieldState('busy', 'Reading files');  // invisible error - wait for files to be read, but stop form from sending
				return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
					ngModel.$setViewValue(values);
					[].push.apply(self.items, values);
					self.is_busy = false;
					fieldBox.setFieldState('valid', null);
					delete fieldBox.errors[fieldBox.field.name];
				}).catch(function(e){
					self.message={type:'danger', body:e}
					self.is_busy = false;
					if (fieldBox) {
						fieldBox.errors[fieldBox.field.name] = 'Error while reading file: ' + e;
						fieldBox.setFieldState('invalid', 'Error while reading file: ' + e);
					}
				});
			}

			$scope.$watch(function(){return self.invalidFiles}, function(currval) {
				self.invalidItems.length = 0;
				if (currval.$error) {
					self.invalidItems.push(currval);
				} else if (currval.length) {
					[].push.apply(self.invalidItems, currval);
				}
				if (self.invalidItems.length) {
					fieldBox.errors[fieldBox.field.name] = 'Some files are invalid';
					fieldBox.setFieldState('invalid', 'Some files are invalid');
				} else {
					fieldBox.setFieldState('valid', null);
					delete fieldBox.errors[fieldBox.field.name];
				}
			})

			self.remove = function(obj) {
				for (var i in self.items) {
					if (self.items[i] === obj) {
						self.items.splice(i, 1);
						break;
					}
				}
				for (var i in self.invalidItems) {
					if (self.invalidItems[i] === obj) {
						self.invalidItems.splice(i, 1);
						break;
					}
				}
			}

			ngModel.$render = function() {
				self.items = ngModel.$modelValue;
			};

			$scope.$formFiles = self;
		},
	}
}

angular.module('forms.fields.formbuilder', [])
.directive('formBuilderField', FormBuilderField)
.directive('formViewField', FormViewField)
.directive('formBuilderCheckboxGroup', FormBuilderCheckboxGroup)
.directive('formFilesField', FormFilesField);
